"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const config_1 = require("config");
const React = require("react");
const LoggerHelper_1 = require("src/ts/helpers/LoggerHelper");
const ConfigContext_1 = require("../../contexts/ConfigContext");
const StackNavigationContext_1 = require("../../contexts/StackNavigationContext");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const Footer_1 = require("../common/Footer");
const Header_1 = require("../common/Header");
const Padder_1 = require("../common/Padder");
const LoginView_1 = require("./LoginView");
class JoinView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._downloadSkype = () => {
            return () => {
                LoggerHelper_1.logger.action({ name: 'download' });
                LoggerHelper_1.logger.sessionFinished({ completionType: 'DownloadSkypeButton' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
                const downloadUrl = EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.MacOS ? config_1.default.urls.app.downloadDesktop : config_1.default.urls.app.download;
                window.location.href = downloadUrl;
            };
        };
    }
    renderLogo(theme) {
        return (React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => React.createElement(react_1.Image, { src: `${configContext.basePath}${theme.siteVariables.brandIcon}`, className: 'logo', "aria-hidden": 'true' })));
    }
    renderTitle() {
        return React.createElement(React.Fragment, null,
            React.createElement(react_1.Header, { as: 'h1', className: 'title' }, bew_localization_1.localizer.getString('Meetings.txt_join_meeting_title')));
    }
    renderDesktopBody() {
        if (EnvironmentHelper_1.deviceType !== EnvironmentHelper_1.DeviceTypes.Desktop) {
            return null;
        }
        return React.createElement(react_1.Text, { size: 'medium', className: 'body' },
            bew_localization_1.localizer.getString('Meetings.txt_join_meeting_description'),
            "\u00A0",
            React.createElement(react_1.Button, { key: 0, id: 'btnLaunchNow', onClick: this.props.onLaunchClick, className: 'fakeLink', "aria-label": `${bew_localization_1.localizer.getString('Meetings.txt_join_meeting_description')} ${bew_localization_1.localizer.getString('Meetings.lnk_join_meeting_retry')}`, text: true }, bew_localization_1.localizer.getString('Meetings.lnk_join_meeting_retry')));
    }
    renderControls() {
        if (EnvironmentHelper_1.deviceType === EnvironmentHelper_1.DeviceTypes.Mobile) {
            return React.createElement(react_1.Button, { key: 1, id: 'btnDownload', primary: true, text: false, onClick: this._downloadSkype() }, bew_localization_1.localizer.getString('btn_launch_download_skype'));
        }
        return React.createElement(React.Fragment, null,
            EnvironmentHelper_1.canJoinOnWeb && React.createElement(StackNavigationContext_1.StackNavigationContextConsumer, null, (stackNavigationContext) => React.createElement(react_1.Button, { key: 0, id: 'btnJoin', primary: true, autoFocus: true, onClick: () => {
                    LoggerHelper_1.logger.sessionIntermediateStep({ eventType: 'JoinOnWebAsGuestInitialClickOldView' });
                    stackNavigationContext.push(React.createElement(LoginView_1.LoginView, null), {
                        eventViewName: 'login-view',
                        animation: StackNavigationContext_1.defaultFadeAnimation,
                        ariaMessage: { assertive: true, text: bew_localization_1.localizer.getString('Login.txt_sign_in_with_title') }
                    });
                } }, bew_localization_1.localizer.getString('Meetings.btn_join_on_web'))),
            React.createElement(react_1.Button, { key: 1, id: 'btnDownload', primary: !EnvironmentHelper_1.canJoinOnWeb, text: EnvironmentHelper_1.canJoinOnWeb, onClick: this._downloadSkype() }, bew_localization_1.localizer.getString('btn_launch_download_skype')));
    }
    renderMobileBody() {
        if (EnvironmentHelper_1.deviceType !== EnvironmentHelper_1.DeviceTypes.Mobile) {
            return null;
        }
        return React.createElement(React.Fragment, null,
            React.createElement(react_1.Text, { size: 'medium', className: 'body' }, bew_localization_1.localizer.getString('Meetings.txt_join_meeting_description')),
            React.createElement(react_1.Text, { size: 'medium' },
                React.createElement("a", { href: 'javascript:void(0);', onClick: this.props.onLaunchClick, style: { textDecoration: 'none', color: '#0078d4' } }, bew_localization_1.localizer.getString('btn_launch_join'))));
    }
    render() {
        return React.createElement("div", { className: 'meetings joinView' },
            React.createElement(Header_1.Header, null),
            React.createElement(Padder_1.Padder, null),
            React.createElement("div", { className: 'scrollable-y' },
                React.createElement(react_1.ProviderConsumer, { render: this.renderLogo.bind(this) }),
                this.renderTitle(),
                this.renderControls(),
                this.renderMobileBody(),
                this.renderDesktopBody()),
            React.createElement(Padder_1.Padder, null),
            React.createElement(Footer_1.Footer, null));
    }
}
exports.JoinView = JoinView;
